module.exports = __webpack_public_path__ + "static/media/wechatpay.827dd7ce.svg";